import { render, staticRenderFns } from "./Contact_details.vue?vue&type=template&id=ebc3457e&scoped=true&lang=pug&"
import script from "./Contact_details.vue?vue&type=script&lang=coffee&"
export * from "./Contact_details.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc3457e",
  null
  
)

export default component.exports